import ax from './axios';
import { formDataFromParams } from './utils';

// Whether email magic-link sign-in is enabled (so the UI can hide the section).
export const emailConfig = () => {
  return ax({ url: '/rest/passwordless/email/config/', method: 'get' });
};

// Request a one-time sign-in link by email. Generic success regardless of
// whether the email exists (anti-enumeration).
export const emailRequest = (email) => {
  return ax({
    url: '/rest/passwordless/email/request/',
    method: 'post',
    data: formDataFromParams({ email }),
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
  });
};

// Consume a magic-link token (POSTed from the landing page in the same browser).
// agentLoginId disambiguates when the email maps to several tenant accounts.
export const emailVerify = (token, agentLoginId) => {
  const params = { token };
  if (agentLoginId) {
    params.agent_login_id = agentLoginId;
  }
  return ax({
    url: '/rest/passwordless/email/verify/',
    method: 'post',
    data: formDataFromParams(params),
    config: { headers: { 'Content-Type': 'multipart/form-data' } },
  });
};
